export default __webpack_public_path__ + "static/fav-5873318d3dd2dccfa0ecdd7abf10a422.png";